module.exports = {"apiEndpointDev":"http://localhost:59988/api","apiEndpoint":"http://betview.be/api/api","imagesUrl":"http://betview.be/images/"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 4
// module chunks = 0